// src/hooks/useRunUsage.js

import { useCallback, useEffect, useState } from 'react';
import { getMaxRunsForPlan, hasUnlimitedRuns } from '../config/plans';

export const useRunUsage = (user) => {
  const [runsUsedThisMonth, setRunsUsedThisMonth] = useState(0);
  const [lastResetDate, setLastResetDate] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setRunsUsedThisMonth(0);
      setLastResetDate(null);
      setIsLoading(false);
      return;
    }

    const usage = user.usage?.runs || {};
    setRunsUsedThisMonth(usage.countThisMonth ?? 0);
    setLastResetDate(usage.lastResetDate ? new Date(usage.lastResetDate) : null);
    setIsLoading(false);
  }, [user]);

  const maxRuns = user ? getMaxRunsForPlan(user) : 0;
  const isUnlimited = hasUnlimitedRuns(user);
  const hasReachedLimitForRun = !isUnlimited && runsUsedThisMonth >= maxRuns;

  const incrementRun = useCallback(() => {
    if (isUnlimited || !user) return;

    // Mise à jour locale immédiate
    setRunsUsedThisMonth((prev) => prev + 1);
  }, [isUnlimited, user]);

  return {
    runsUsedThisMonth,
    maxRuns,
    hasReachedLimitForRun,
    isUnlimited,
    isLoading,
    incrementRun,
  };
};